"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFooterTextId = exports.buildDescriptionTextId = exports.buildAriaDescribedby = void 0;
const buildFooterTextId = id => "".concat(id, "-footer");
exports.buildFooterTextId = buildFooterTextId;
const buildDescriptionTextId = id => "".concat(id, "-description");
exports.buildDescriptionTextId = buildDescriptionTextId;
const buildAriaDescribedby = (footerId, descriptionId) => {
  if (!footerId && !descriptionId) return undefined;
  if (!footerId) return descriptionId;
  if (!descriptionId) return footerId;
  return "".concat(descriptionId, " ").concat(footerId);
};
exports.buildAriaDescribedby = buildAriaDescribedby;